export const CDK_OVERLAY_HOLDER = 'cdk-overlay-holder';
